
import {useState, useEffect} from 'react';
import TextField from "../../fragments/form/TextField"
import CheckboxSelector from "../../fragments/form/CheckboxSelector"
import SubmitButton from "../../fragments/form/SubmitButton"


function CreateStateForm(props) {
    const [formData, setFormData] = useState(new FormData());

    useEffect(()=>{
        formData.set("country_id",props.countryId);
        setFormData(formData);
    },[])

    const onChange = (id, value) => {
        formData.set(id, value);
        setFormData(formData);
    }

    const onSubmit = (e) => {
        e.preventDefault();
        props.onSubmit(formData)
    }

    return (
        <form onSubmit={onSubmit}>
            <TextField id="state" required={true} onChange={onChange} label="Name" onLoad={() => onChange("state", "")}  />
            <CheckboxSelector id="is_published" required={true} onChange={onChange} label="Publish" onLoad={() => onChange("is_published", "0")} />
            <SubmitButton />
        </form>
    );
}

export default CreateStateForm;